<template>
  <transition name="fade">
    <div v-if="value" class="popup_box" style="display: block">
      <div class="popup delete_category">
        <span class="page_title">Добавление товара</span>
        <span class="close_popup" @click="cancel()"></span>
        <div style="margin-bottom: 20px; position: relative; z-index: 1200">
          <p style="color: white">Товар:</p>
          <super-select
              v-model="product_id"
              key="select-product"
              item-key="product-item"
              :items="products"
              field-name="full_name"
              clearable="true"
              @search="searchProduct"
          />
        </div>
        <button :disabled="is_loading || product_id === null" class="btn" @click="save()">Сохранить</button>
        <button class="btn empty" @click="cancel()">Отменить</button>
      </div>
    </div>
  </transition>
</template>

<script>
import SuperSelect from '@/components/Helpers/SuperSelect/SuperSelect.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { eventBus } from '@/main'

export default {
  name: 'AddSenderProductModal',
  components: { SuperSelect },
  props: ['value'],
  emits: ['input', 'added'],
  data () {
    return {
      is_loading: false,
      product_id: null
    }
  },
  computed: {
    ...mapState('product', ['products'])
  },
  methods: {
    ...mapActions('product', ['getProducts']),
    ...mapActions('senders', ['addSenderProducts']),
    ...mapMutations('product', ['setPage', 'setSearch']),
    cancel () {
      this.$emit('input', false)
    },
    save () {
      this.is_loading = true
      const data = {
        sender_id: this.$route.params.id,
        product_id: this.product_id
      }

      this.addSenderProducts(data).then(response => {
        this.is_loading = false
        eventBus.$root.$emit(
          'send_notify',
          'success',
          response.data.message
        )
        this.product_id = null
        this.$emit('added', false)
      }).catch(() => {
        this.is_loading = false
      })
    },
    searchProduct (search) {
      this.setSearch(search)
      this.setPage(1)
      this.getProducts()
    }
  }
}
</script>

<style scoped>

</style>
